export default __webpack_public_path__ + "static/media/Group1746.5dd5a3e8.svg";